// frontend/src/components/Register.tsx
import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert, InputGroup } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

import { API_BASE_URL } from '../config/api';

const Register: React.FC = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    password2: '',
    full_name: '',
    phone_number: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // בדיקת תקינות
    if (formData.password !== formData.password2) {
      setError('הסיסמאות אינן תואמות');
      return;
    }

    if (formData.password.length < 8) {
      setError('הסיסמה חייבת להכיל לפחות 8 תווים');
      return;
    }

    setLoading(true);

    try {
      const result = await register(formData);
      
      if (result.success) {
        setSuccess(result.message);
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        setError(result.message);
      }
    } catch (err: any) {
      console.error('Registration error:', err);
      
      if (err.response?.data) {
        const errorData = err.response.data;
        
        // טיפול בשגיאות ספציפיות לשדות
        if (errorData.username) {
          setError(Array.isArray(errorData.username) ? errorData.username[0] : errorData.username);
        } else if (errorData.email) {
          setError(Array.isArray(errorData.email) ? errorData.email[0] : errorData.email);
        } else if (errorData.password) {
          setError(Array.isArray(errorData.password) ? errorData.password[0] : errorData.password);
        } else if (errorData.password2) {
          setError(Array.isArray(errorData.password2) ? errorData.password2[0] : errorData.password2);
        } else if (errorData.detail) {
          setError(errorData.detail);
        } else if (errorData.non_field_errors) {
          setError(Array.isArray(errorData.non_field_errors) ? errorData.non_field_errors[0] : errorData.non_field_errors);
        } else {
          // אם יש שגיאות מרובות, הצג את הראשונה
          const firstError = Object.values(errorData)[0];
          setError(Array.isArray(firstError) ? firstError[0] : String(firstError));
        }
      } else {
        setError(err.message || 'שגיאה בהרשמה. אנא נסה שוב.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5" style={{ maxWidth: '600px', direction: 'rtl' }}>
      <Card>
        <Card.Header as="h3" className="text-center">
          הרשמה למערכת
        </Card.Header>
        <Card.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}
          
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>שם משתמש *</Form.Label>
              <Form.Control
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                disabled={loading || !!success}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>אימייל *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={loading || !!success}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>שם מלא</Form.Label>
              <Form.Control
                type="text"
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                disabled={loading || !!success}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>מספר טלפון</Form.Label>
              <Form.Control
                type="tel"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
                disabled={loading || !!success}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>סיסמה * (לפחות 8 תווים)</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  minLength={8}
                  disabled={loading || !!success}
                  autoComplete="new-password"
                />
                       <Button
                         variant="outline-secondary"
                         onClick={() => setShowPassword(!showPassword)}
                         disabled={loading || !!success}
                       >
                         {showPassword ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}
                       </Button>
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>אימות סיסמה *</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showPassword2 ? 'text' : 'password'}
                  name="password2"
                  value={formData.password2}
                  onChange={handleChange}
                  required
                  minLength={8}
                  disabled={loading || !!success}
                  autoComplete="new-password"
                />
                       <Button
                         variant="outline-secondary"
                         onClick={() => setShowPassword2(!showPassword2)}
                         disabled={loading || !!success}
                       >
                         {showPassword2 ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}
                       </Button>
              </InputGroup>
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100 mb-3"
              disabled={loading || !!success}
            >
              {loading ? 'נרשם...' : 'הרשמה'}
            </Button>
          </Form>

          

          <div className="text-center">
            <p className="mb-2">כבר יש לך חשבון?</p>
            <Link to="/login">
              <Button variant="outline-primary" className="w-100">
                התחברות
              </Button>
            </Link>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Register;
